import api from '../api';

import { ParamsBodyPostSendToken } from 'utils/typeServices';

export const PostSendToken = async ({ body }: { body: ParamsBodyPostSendToken }) => {
    const bodyJson = JSON.stringify({
        CdPerson: body.CdPerson,
        ContatoClienteEnum: body.ContatoClienteEnum,
        PhoneId: body.PhoneId,
        SendToEmail: body.SendToEmail,
    });

    try {
        const { data } = await api.post<{ Data: boolean }>('/v1/Cliente/SendToken', bodyJson);

        return { data: data.Data };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
